<template>
  <div class="qa">
    <div class="qaBox">
        <h4 class="aboutH4">{{$t('qa.QAH')}}</h4>
        <div class="qaBoxBot">
          <div class="qaBoxTop">
            <p class="aTitle">{{$t('qa.t')}}</p>
            <p class="aboutP2">{{$t('qa.Q1')}}</p>
            <p class="aboutP3" v-html="$t('qa.A1')"></p>
            <p class="aTitle">{{$t('qa.t2')}}</p>
            <p class="aboutP2">{{$t('qa.Q2')}}</p>
            <p class="aboutP3" v-html="$t('qa.A2')"></p>
            <p class="aboutP2">{{$t('qa.Q3')}}</p>
            <p class="aboutP3" v-html="$t('qa.A3')"></p>
            <p class="aboutP2">{{$t('qa.Q4')}}</p>
            <p class="aboutP3" v-html="$t('qa.A4')"></p>
            <p class="aTitle">{{$t('qa.t3')}}</p>
            <p class="aboutP2">{{$t('qa.Q5')}}</p>
            <p class="aboutP3" v-html="$t('qa.A5')"></p>
            <p class="aboutP2">{{$t('qa.Q6')}}</p>
            <p class="aboutP3" v-html="$t('qa.A6')"></p>
            <p class="aboutP2">{{$t('qa.Q7')}}</p>
            <p class="aboutP3" v-html="$t('qa.A7')"></p>
            <p class="aboutP2">{{$t('qa.Q8')}}</p>
            <p class="aboutP3" v-html="$t('qa.A8')"></p>
            <p class="aboutP2">{{$t('qa.Q9')}}</p>
            <p class="aboutP3" v-html="$t('qa.A9')"></p>
            <p class="aboutP2">{{$t('qa.Q10')}}</p>
            <p class="aboutP3" v-html="$t('qa.A10')"></p>
            <p class="aboutP2">{{$t('qa.Q11')}}</p>
            <p class="aboutP3" v-html="$t('qa.A11')"></p>
          </div>
        </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'qa',
  computed: {},
  data() {
    return {
    }
  },
  mounted() {},
  methods: {},
}
</script>

<style lang="stylus" scoped>
.qa{
  background $color-white
  .aboutP2 {
    font-weight: bold
  }
  .aTitle {
    font-size: 24px;
    font-weight: bold;
    color $color-main;
    margin-bottom: 20px;
  }
  .qaBoxTop{
    width $container-width-1200
    margin auto
  }
  .qaBox{
    margin 85px 0 0 0
    .aboutH4{
      text-align center
      color $color-main
      font-size 20px
      margin-bottom 38px;
    }
    .aboutP,.aboutP1,.aboutP2,.aboutP3{
      margin auto
      color $color-black-65
      font-size 16px
      margin-bottom 24px
    }
    .aboutP,.aboutP1{
      width 1050px;
    }
    .aboutP1{
      margin-top 40px;
    }
    .aboutP2{
      width $container-width-1200
      color $color-main
      font-size 18px
      margin-bottom 24px
    }
    .aboutP3{
      width $container-width-1200
    }
    .qaImg{
      width 100%
      margin-bottom 24px
    }
  }
  .qaBoxBot{
    width 100%
    background $color-white 
    padding 50px 0 
  }
}
</style>
